<template>
	<div ref="el" data-component="card-benefit">
		<div class="icon-wrapper">
			<Icon :slug="icon" class="icon" size="md" />
		</div>

		<p class="-body-medium title">{{ title }}</p>
	</div>
</template>

<script setup>
import { Icon } from '~/components/core'

const props = defineProps({
	icon: { type: [Boolean, String], default: 'ic-ai-inside' },
	title: { type: String, default: 'No title' },
})

const el = ref(null)
const context = inject('pageContext')

const setup = () => {}
const init = () => {}
const kill = () => {}

onBeforeUnmount(() => {})
onMounted(() => {
	context.$page.loader.loaded.then(() => setup())
	context.$page.loader.transitionReady.then(() => init())
})
</script>

<style lang="scss" scoped>
[data-component='card-benefit'] {
	position: relative;

	display: flex;
	flex-direction: column;
	justify-content: space-between;

	flex-shrink: 0;

	height: rs(120, 120);
	width: rs(190, 190);
	padding: rs(14, 14);

	background-color: rgba(var(--color-river-blue-50-rgb), 0.8);
	background-color: var(--color-river-blue-50);

	border-radius: rs(12, 12);

	.icon-wrapper {
		--icon-color: #{var(--color-river-blue-500)};

		display: flex;
		justify-content: center;
		align-items: center;

		width: rs(40, 40);
		height: rs(40, 40);

		border-radius: 50px;
		background-color: var(--color-river-blue-100);
	}

	.title {
		color: var(--color-neutral-tints-600);
	}
}
</style>
